<template>
  <div v-editable="blok" class="image" :aria-label="blok.description" :title="blok.description">
    <img :src="blok.asset?.filename" :alt="blok.description" />
    <p v-if="blok.title">{{ blok.title }}</p>
  </div>
</template>

<script setup lang="ts">
import { StoryblokPreviewImageBlok } from '@/features/storyblok/types';

const props = defineProps<{
  blok: StoryblokPreviewImageBlok;
}>();
</script>

<style scoped>
.image {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px;
  background: var(--ion-background-color);
}
.image img {
  max-width: 100%;
  height: auto;
  border-radius: var(--ion-radius-xl);
}
.image p {
  margin-top: var(--ion-space-2);
  color: var(--ion-text-color);
}
</style>
